import styled from 'styled-components';
import { ReactComponent as ListViewImage } from 'Images/list_view.svg';
import { ReactComponent as GridViewImage } from 'Images/grid_view.svg';
import { disableTextSelection } from 'Styles/effects/text';
import Button from 'shared/ui/Button';
import { typography } from 'shared/ui/tokens';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  ${disableTextSelection}
`;
Wrapper.displayName = 'Wrapper';

export const ListViewIcon = styled(ListViewImage)`
  height: auto;
`;
ListViewIcon.displayName = 'ListViewIcon';

export const GridViewIcon = styled(GridViewImage)`
  height: auto;
  & > g{
    fill: ${({ theme }) => theme.buttons.custom.color};
  }
`;
GridViewImage.displayName = 'GridViewImage';

export const CustomButton = styled(Button).attrs({ variant: 'secondary' })`
  && {
    background-color: ${({ theme }) => theme.buttons.custom.background};
    border-color: ${({ theme }) => theme.buttons.custom.border};
    color: ${({ theme }) => theme.buttons.custom.color};
    font-size: ${typography.fontSize.sm};

    &:hover {
      background-color: ${({ theme }) => theme.buttons.custom.backgroundHover};
    }
  }
`;
CustomButton.displayName = 'CustomButton';
